import React from "react";
import { Form } from "react-bootstrap";
import "../../../landnotification.css";

export default function SelectField(props) {
  const { formGroup, onChange, disabled, selectButton } = props;

  let clazzName = "form-inline-block";
  if (formGroup.layout === "horizontal") {
    clazzName = "form-inline search-results-sort-dropdown";
  }
  if (formGroup.fullWidth === true) {
    clazzName = "form-full-width";
  }

  // Default options
  let options = formGroup.options;
  if (!options) {
    options = [
      { code: true, description: "Yes" },
      { code: false, description: "No" },
    ];
  }

  const size = formGroup.size || "md";

  let controlStyle = formGroup.style;
  if (formGroup.fullWidth === true) {
    controlStyle = { ...controlStyle, fontSize: "16px" };
  }

  const errorClassName = formGroup.error === true ? "field-error" : undefined;

  // ---------------- SELECT FIELD ----------------
  let formControl;

  if (formGroup.disableField === true || disabled === true) {
    formControl = (
      <Form.Control size={size} id={formGroup.id} className={errorClassName} style={controlStyle} as={formGroup.fieldType} disabled onChange={onChange} value={formGroup.value} >
        {options.map((option) => (
          <option key={option.code} value={option.code}>
            {option.description}
          </option>
        ))}
      </Form.Control>
    );
  } else {
    formControl = (
      <Form.Control size={size} id={formGroup.id} className={errorClassName} style={controlStyle} as='select' onChange={onChange} value={formGroup.value} >
        {options.map((option) => (
          <option key={option.code} value={option.code}>
            {option.description}
          </option>
        ))}
      </Form.Control>
    );
  }

  // ---------------- OPTIONAL BUTTON ----------------
  const buttonControl = selectButton || null;

  // ---------------- LABEL STYLE ----------------
  const fontWeight = formGroup.primaryCriteria ? "bold" : "normal";

  let label = null;
  let floatStyle = "right";
  const mobileLabelStyle = formGroup.fullWidth === true ? { fontSize: "13px", fontWeight: "bold", color: "#114E6B" } : undefined;

  if (formGroup.layout === "horizontal") {
    label = formGroup.label ? ( <label style={mobileLabelStyle} htmlFor={formGroup.labelFor}> {formGroup.label}: </label> ) : null;
    floatStyle = formGroup.label ? "right" : "left";
  } else {
    label = formGroup.label ? ( <label style={mobileLabelStyle} htmlFor={formGroup.labelFor}> {formGroup.label}: </label> ) : ( <span>&nbsp;</span> );
  }

  if (formGroup.fullWidth === true) {
    floatStyle = "none";
  }

  return (
    <div className={clazzName} style={{ fontWeight, float: floatStyle }}>
      <div>{label}</div>
      {formControl}
      {buttonControl}
    </div>
  );
}